define('services/trace',["require", "exports", "durandal/system"], function (require, exports, system) {
    "use strict";
    function trace(message, data, source, showToast) {
        write(message, data, source, showToast, 'info');
    }
    exports.trace = trace;
    function traceInformation(message) {
        write(message, null, null, true, 'info');
    }
    exports.traceInformation = traceInformation;
    function traceWarning(message) {
        write(message, null, null, true, 'warning');
    }
    exports.traceWarning = traceWarning;
    function traceError(message, data, source, showToast) {
        if (data === void 0) { data = null; }
        if (source === void 0) { source = null; }
        if (showToast === void 0) { showToast = true; }
        write(message, data, source, showToast, 'error');
    }
    exports.traceError = traceError;
    function write(message, data, source, showToast, toastType) {
        source = source ? '[' + source + '] ' : '';
        if (data) {
            system.log(source, message, data);
        }
        else {
            system.log(source, message);
        }
        if (showToast) {
            if (toastType === 'error') {
                toastr.error(message);
            }
            else {
                toastr.info(message);
            }
        }
    }
});

